import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInvoice = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.49667 1.25V4.91667C8.49667 5.27029 8.63714 5.60943 8.88719 5.85948C9.13724 6.10952 9.47638 6.25 9.83 6.25H13.4967M4.75 9H7.2506M4.75 11.5L7.2506 11.5213M8.75244 9H11.25M8.75244 11.5H11.25M9.16337 1.25H3.83333C3.47971 1.25 3.14057 1.39048 2.89052 1.64052C2.64048 1.89057 2.5 2.22971 2.5 2.58333V13.42C2.5 13.7736 2.64048 14.1128 2.89052 14.3628C3.14057 14.6129 3.47971 14.7533 3.83333 14.7533H12.1633C12.517 14.7533 12.8561 14.6129 13.1061 14.3628C13.3562 14.1128 13.4967 13.7736 13.4967 13.42V5.58669L9.16337 1.25Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgInvoice;
